import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useUsernameEmailSafetyTracking() {
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function sendPromptView() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.USERNAME_EMAIL_SAFETY_PROMPT_VIEW,
      { schemaVersion: '1.0' }
    );
  }

  function sendPromptUpdateUsernameAction() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.USERNAME_EMAIL_SAFETY_PROMPT_UPDATE_USERNAME_ACTION,
      { schemaVersion: '1.0' }
    );
  }

  function sendPromptDismissAction() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.USERNAME_EMAIL_SAFETY_PROMPT_DISMISS_ACTION,
      { schemaVersion: '1.0' }
    );
  }

  return {
    sendPromptView,
    sendPromptUpdateUsernameAction,
    sendPromptDismissAction,
  };
}
